import React from "react";
import { useHistory } from "react-router-dom";
import { OBJECT_TYPE, WORKFLOW_STEP_ROLE } from "common/constants";
import { buildLink } from "common/routing";
import { GetWorkflowQuery } from "../../../generated/graphql";
import { spacing } from "../../../stitches.config";
import { FlexRow } from "../../Common/__styles__/Layout";
import { Button } from "../../Common/Button";
import { Icon } from "../../Common/Icons/LucideIcons";
import { Tag } from "../../Common/Tag";
import { WorkflowStepContainer } from "./__styles__/WorkflowStep";

export const WorkflowStep = ({
  workflowStep,
  objectId,
  objectType,
}: {
  workflowStep: Omit<
    NonNullable<GetWorkflowQuery["workflow"]>["workflowSteps"][number],
    "status"
  >;
  objectId?: string;
  objectType?: OBJECT_TYPE;
}) => {
  const history = useHistory();

  let onCallToActionClick: (() => void) | undefined;

  if (
    workflowStep.workflowStepUser?.stepRole === WORKFLOW_STEP_ROLE.CREATE &&
    !workflowStep.submission
  ) {
    onCallToActionClick = () =>
      history.push(
        buildLink("createSubmission", {
          submissionTypeId:
            workflowStep.workflowStepDefinition.submissionType.id,
          objectId: objectId ?? undefined,
          objectType: objectType ?? undefined,
        })
      );
  } else if (workflowStep.submission) {
    onCallToActionClick = () =>
      history.push(
        buildLink("editSubmission", {
          submissionId: workflowStep.submission!.id,
        })
      );
  }

  let ctaText: string;
  switch (workflowStep.workflowStepUser?.stepRole) {
    case WORKFLOW_STEP_ROLE.CREATE:
      ctaText = workflowStep.submission ? "View" : "Create";
      break;
    case WORKFLOW_STEP_ROLE.UPDATE:
      ctaText = "Review";
      break;
    case WORKFLOW_STEP_ROLE.VIEW:
      ctaText = "View";
      break;
    case undefined:
      ctaText = "View";
      break;
  }

  return (
    <WorkflowStepContainer>
      <FlexRow style={{ gap: spacing.s.value, alignItems: "center" }}>
        <Icon iconName="file-text" color="contentSecondary" size={20} />
        {workflowStep.workflowStepDefinition.submissionType.name}
      </FlexRow>
      <FlexRow style={{ gap: spacing.l.value, alignItems: "center" }}>
        {workflowStep.workflowStepUser?.tag && (
          <Tag styleVariant="default">{workflowStep.workflowStepUser?.tag}</Tag>
        )}
        <Button
          styleVariant="outlineLight"
          size="small"
          fitContent
          onClick={onCallToActionClick}
          disabled={!onCallToActionClick}
        >
          {ctaText}
        </Button>
      </FlexRow>
    </WorkflowStepContainer>
  );
};
